export default [
  {
    id: 'required',
    description: 'Campo obrigatório'
  },

  {
    id: 'sistemaIndisponivel',
    description: 'Sistema Temporariamente Indisponível.'
  },
  {
      id: 'usuarioSemVinculoEmpresa',
      description: 'Não existe empresa ou instituição vinculada ao usuário. Por gentileza, entre em contato com o MCTI.'
  },
  {
    id: 'usuarioSemPerfilAcessoPleito',
    description: 'O usuário não possui perfil para acessar esse serviço. Por gentileza, entre em contato com o MCTIC.'
  },
  {
    id: 'maxlength',
    description: 'Quantidade máxima de caracteres excedida'
  },
  {
    id: 'matDatepickerParse',
    description: 'Data inválida'
  },
  {
    id: 'matDatepickerMax',
    description: 'Data inválida'
  },
  {
    id: 'matDatepickerMin',
    description: 'Data inválida'
  },
  {
    id: 'minlength',
    description: 'Informação incompleta'
  },
  {
    id: 'email',
    description: 'E-mail informado é inválido.'
  },
  {
    id: 'telefone',
    description: 'Telefone informado é inválido.'
  },
  {
    id: 'extensaoInvalida',
    description: 'Extensão inválida'
  },
  {
    id: 'tamanhoArquivoInvalido',
    description: 'Tamanho do arquivo excedido'
  },
  {
    id: 'cnpj',
    description: 'CNPJ inválido'
  },
  {
    id: 'max',
    description: 'Tamanho máximo excedido'
  },
  {
    id: 'MSG002',
    description: 'Operação realizada com sucesso!'
  },
  {
    id: 'MSG003',
    description: 'Confirma o cancelamento?'
  },
  {
    id: 'MSG004',
    description: 'Confirma a exclusão?'
  },
  {
    id: 'MSG006',
    description: 'Arquivo Inválido. Verifique a extensão permitida.'
  },
  {
    id: 'MSG008',
    description: 'Conforme regra de depreciação, a data de aquisição deve ser menor que 5 anos.'
  },
  {
    id: 'MSG009',
    description: 'Tamanho do arquivo excedido. O valor máximo é de 15Mb.'
  },
  {
    id: 'MSG010',
    description: 'A data de início e fim deve estar dentro do período de vigência do projeto.'
  },
  {
    id: 'MSG011',
    description: 'Colaborador não cadastrado no dispêndio de Recurso Humano.'
  },
  {
    id: 'MSG012',
    description: 'Nenhum registro encontrado.'
  },
  {
    id: 'MSG013',
    description: 'A Instituição selecionada é do tipo Incubadora. Informe a Razão Social da empresa incubada que realizou o projeto.'
  },
  {
    id: 'MSG014',
    description: 'Esta propriedade intelectual está associada a outro (s) projeto (s) por isso não pode ser excluída.'
  },
  {
    id: 'MSG016',
    description: 'O custo incorrido pela Instituição não pode ser superior a 20% do Valor total repassado para a instituição.'
  },
  {
    id: 'MSG020',
    description:
      'A soma dos valores informados na obrigação de aplicação em P,D&I difere do valor da Obrigação adicional ' +
      'relativa à troca de PPB por P,D&I.'
  },
  {
    id: 'MSG026',
    description: 'A data final deve ser maior que a inicial.'
  },
  {
    id: 'MSG029',
    description: 'CNPJ não encontrado na lista de Empresas Contratantes. Entre em contato com o MCTI.'
  },
  {
    id: 'MSG031',
    description: 'Nenhuma empresa selecionada.'
  },

  {
    id: 'MSG046',
    description: 'A data início não pode ser maior que o último dia do ano base.'
  },
  {
    id: 'MSG047',
    description: 'Data início inválida.'
  },
  {
    id: 'MSG048',
    description: 'Data fim inválida.'
  },
  {
    id: 'MSG058',
    description: 'Tamanho do arquivo excedido. O valor máximo é de 50Mb.'
  },
  {
    id: 'MSG069',
    description: 'Configuração já cadastrada para a região.'
  },
  {
    id: 'MSG070',
    description: 'A empresa não realizou o envio do RDA, por este motivo não será possível enviar o relatório conclusivo de auditoria independente'
  },

  {
    id: 'MSG073',
    description: 'Existe região sem parâmetros configurados.'
  },
  {
    id: 'MSG076',
    description: 'As informações não salvas serão perdidas. Deseja continuar?'
  },
  {
    id: 'MSG077',
    description: 'Nenhuma instituição selecionada.'
  },
  {
    id: 'MSG080',
    description: 'PERÍODO DE ENVIO DE RDA ENCERRADO!'
  },
  {
    id: 'MSG081',
    description: 'Ao utilizar a configuração deste ano base, as informações preenchidas serão perdidas. Deseja continuar?'
  },
  {
    id: 'MSG083',
    description: 'Período de suspenção, por este motivo não será possível enviar o relatório conclusivo de auditoria independente'
  },
  {
    id: 'MSG084',
    description: 'Deseja confirmar o Envio do RDA? Ele não poderá ser enviado novamente.'
  },
  {
    id: 'MSG096',
    description: 'A data limite de regularização será <data>. Confirma Prorrogação?'
  },
  {
    id: 'MSG097',
    description: 'Prorrogação realizada com sucesso!'
  },
  {
    id: 'MSG106',
    description: 'Produto cadastrado com sucesso!'
  },
  {
    id: 'MSG109',
    description: 'Modelo já cadastrado!'
  },
  {
    id: 'MSG110',
    description: 'Não é possível incluir o componente. O valor total de percentual excede o valor de cem por cento.'
  },
  {
    id: 'MSG113',
    description: 'NCM inválido!'
  },
  {
    id: 'MSG116',
    description: 'Estabelecimento Beneficiário de Incentivo já cadastrado!'
  },
  {
    id: 'MSG117',
    description: 'Ao menos um anexo deve ser incluído a lista!'
  },
  {
    id: 'MSG118',
    description: `Com exigência`
  },
  {
    id: 'MSG119',
    description: `Sem exigência`
  },
  {
    id: 'MSG120',
    description: `Sem Justificativa`
  },
  {
    id: 'MSG121',
    description: `Não é possível submeter o pleito a análise. Favor vincular produtos ao Pleito.`
  },
  {
    id: 'MSG122',
    description: `Informações registradas com sucesso. Para submeter o pleito a análise é necessário
          que sejam incluídos seus produtos, ação disponível por meio da funcionalidade Cadastrar Novo Produto.`
  },
  {
    id: 'MSG124' ,
    description: `Foi gerado um novo Certificado de Crédito Financeiro.
          Solicita-se o envio pela empresa até o fechamento do trimestre atual.
          Caso o envio não ocorra, o(s) novo(s) certificados gerados serão
          desconsiderados, somente os certificados enviados à Receita Federal,
          são validos para a geração de crédito.`
  },
  {
    id: 'MSG126',
    description: `A empresa encontra-se com débitos no CADIN, favor verificar com
                  o órgão e regularizar sua situação!`
  },
  {
    id: 'MSG128',
    description: `Atualizar informações da entidade.`
  },
  {
    id: 'MSG135',
    description: `Prorrogação solicitada com sucesso.`
  },
  {
    id: 'MSG136',
    description: `O cancelamento do pleito acarretará no cancelamento
                  da habilitação provisória dos produtos vinculados a ele.
                  Confirma a operação?`
  },
  {
    id: 'MSG139',
    description: `Exigência respondida com sucesso. Por favor,
     verifique se no pleito constam produtos em exigência antes de submeter o pleito para análise.`
  },
  {
    id: 'MSG140',
    description: `Informações salvas com sucesso.`
  },
  {
    id: 'MSG145',
    description: `A empresa encontra-se com débitos de FGTS na Caixa Econômica Federal, favor verificar com
                  o órgão e regularizar sua situação!`
  },
  {
    id: 'MSG149',
    description: `Não foram identificadas duas suspensões no período de dois anos.`
  },
  {
    id: 'MSG185',
    description: `A soma dos valores Tecnac e Normal,
                  não pode ser maior que o acumulado!`
  },
  {
    id: 'MSG185B',
    description: `O valor utilizado não pode ser maior que o acumulado!`
  },

  {
    id: 'MSG187A',
    description: `O valor informado no campo “Valor do Faturamento considerado
                  para a Troca:” não pode ser maior que o valor de
                  “Faturamento de Contrapartida”`
  },
  {
    id: 'MSG187B',
    description: `O valor informado no campo “Quantidade Produzida considerado
          para a Troca:” não pode ser maior que o valor de “Quantidade Produzida”`
  },
  {
    id: 'MSG188',
    description: 'Deseja confirmar a exclusão da principal competência?'
  },
  {
    id: 'MSG189',
    description: 'Deseja confirmar a atribuição das permissões ao usuário?'
  },
  {
    id: 'MSG190',
    description: 'Deseja confirmar a revogação de acesso do(a) usuário(a)?'
  },
  {
    id: 'MSG191',
    description: 'Deseja confirmar a ativação de acesso do(a) usuário(a)?'
  },
  {
    id: 'MSG192',
    description: 'Deseja confirmar a revogação de acesso dos(a) usuários(as)?'
  },
  {
    id: 'MSG193',
    description: `Ao desmarcar a seleção do estabelecimento,
    todos os dados de faturamento ou carta gerada serão excluidos.
    Confirma a exclusão?`
  },
  {
    id: 'MSG194',
    description: `Ao enviar o certificado de crédito financeiro para a
    Secretaria da Receita Federal do Brasil, a pessoa jurídica
    habilitada poderá retificá-lo somente durante o período de
    apuração. Assim como não poderá alterar o Regime de Crédito
    escolhido (Trimestral ou Anual). Confirma o envio?`
  },
  {
    id: 'MSG197',
    description: 'Nenhum estabelecimento adicionado!'
  },
  {
    id: 'MSG205',
    description: `Deseja confirmar o envio da recomendação técnica para assinatura?`
  },
  {
    id: 'MSG211',
    description: `O valor excedente acumulado utilizado não pode ser maior que o remanescente.`
  },
  {
    id: 'MSG212',
    description: 'Deseja confirmar o Envio do RDA Padis? Ele não poderá ser enviado/editado novamente.'
  },
  {
    id: 'MSG242',
    description: 'Deseja remover a empresa do regime de crédito?'
  },
  {
    id: 'MSG243',
    description: 'Não foi possível realizar o envio da retificação. Tente efetuar o procedimento novamente ou entre em contato com o suporte do SIGPLANI.'
  },
  {
    id: 'MSG244',
    description: 'Foi gerado um novo Certificado de Crédito Financeiro. Solicita-se o envio pela empresa até o fechamento do ano base atual. Caso o envio não ocorra, o(s) novo(s) certificados gerados serão desconsiderados, somente os certificados enviados à Receita Federal, são validos para a geração de crédito.'
  },

  {
    id: 'MSG998',
    description: 'Preciso duma mensagem aqui ! Existem cartas geradas no periodo anteriormente selecionado, remova as seleções pra mudar o periodo.'
  },
  {
    id: 'MSG997',
    description: 'Preciso duma mensagem aqui ! Devido Alteração de excedente e / ou remanescente será necessário realizar retificações dos trimestres posteriores a carta gerada!.'
  },
  {
    id: 'MSG247',
    description: 'As alterações realizadas até o momento só serão salvas se o certificado retificado for enviado, caso contrário, todos os dados inseridos serão perdidos. Deseja seguir com a mudança do período de retificação?'
  },
  {
    id: 'MSG246',
    description: 'O certificado retificado está na fila para envio à Receita Federal. Para finalizar o envio, será necessário retificar os demais certificados.'
  },

  {
    id: 'MSG231',
    description: `Confirma a inclusão do estabelecimento beneficiário do incentivo?`
  },
  {
    id: 'MSG129',
    description: 'Confirma atualização?'
  },
  {
    id: 'MSGC_ERRO_ANALISE_INCOMPLETA',
    description: `Complete o parecer da análise.`
  },
  { id: 'MSG260',
	  description: 'Existe uma solicitação de prorrogação de prazo em análise, caso seja enviado a(s) resposta(s) exigência(s) não será possível efetuar essa avaliação. Confirma o envio da exigência?'
  },
  { id: 'MSGC_SEM_PERMISSAO',
	  description: 'Usuário sem permissão de acesso.'
  }

];
